<div class="color">
    <div class="container">
        <div class="text">
            <p>
                <strong>QUALITY:</strong><br />– Improved “first time right”
                from 60% to 85% in 4 months.
            </p>
            <p>
                <strong>
                    MINIMIZED SHELFTIME AND KEEPING DELIVERY TOWARDS CUSTOMERS:
                </strong><br />– Automotive industry <br />• 50% reduction of
                the total inventory in 2 years, customer delivery performance:
                98%
            </p>
            <p>
                – Food industry <br />• 25% reduction of the total inventory in
                1 year, customer delivery performance: 99%
            </p>
            <p>
                – Prosess industry <br />• 50% reduction of WIP – Work In
                Progress in 3 months, Customer Delivery Performance 99%
            </p>

            <p>
                <strong>INCREASED SAFETY:</strong><br />– Improved TRI with 80%
                in 1 year
            </p>
            <p>
                <strong>OEE IMPROVEMENT:</strong><br />– Automotive <br />•
                Machine line OEE from 60% to 80% in 3 months <br />– Food
                industry <br />• Packing line OEE from 25% to 66% in 12 months
            </p>
            <p>
                – Process industry <br />• Yield from 88% to 94% and doubled
                volume in 12 months without hiring more people
            </p>
        </div>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 200px;
    }
    @media screen and (max-width: 900px) {
        .container {
            padding-bottom: 100px !important;
        }
    }

    .color {
        background-color: whitesmoke;
    }
</style>
